// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__24HKT","list":"PatternAutocomplete_list__2NIMJ"};